import { render, staticRenderFns } from "./PortfolioItem.vue?vue&type=template&id=6bbe1619"
import script from "./PortfolioItem.vue?vue&type=script&lang=js"
export * from "./PortfolioItem.vue?vue&type=script&lang=js"
import style0 from "./PortfolioItem.vue?vue&type=style&index=0&id=6bbe1619&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports